import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'shared/utils/wix-connect';

import { LinkButton } from 'shared/components/button/button';

import styles from './tab.styl';


@WixConnect(styles)
export default class Tab extends React.Component {

  static propTypes = {
    index: React.PropTypes.number,
    label: React.PropTypes.string,
    className: React.PropTypes.string,
    activeClassName: React.PropTypes.string,
    active: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    getRef: React.PropTypes.func,
  };

  static defaultProps = {
    active: false,
    onClick: _.noop,
    noContentPadding: false,
    getRef: _.noop,
  };

  @autobind
  handleClick() {
    const { onClick, index } = this.props;
    onClick(index);
  }

  render() {
    const { label, active, className, activeClassName, getRef } = this.props;

    const styleNames = classnames('tab', { active });
    const classNames = classnames(className, { [activeClassName]: active && activeClassName });

    return (
      <LinkButton styleName={styleNames}
                  className={classNames}
                  onClick={this.handleClick}
                  getRef={getRef}>
        {label}
      </LinkButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/tabs/tab/tab.js